module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.a16d820.ttf";